export default "__VITE_ASSET__zoZf0k5u__"